try {

  // Vendor libs
  window.$ = window.jQuery;
  window.jQueryBridget = require('jquery-bridget');
  window.Popper = require('popper.js/dist/umd/popper.js').default;

} catch (e) {
  console.log(e);
}
